import React, { useState } from 'react';
import Footer from '../components/Footer';
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import Navbar from "../components/navbar";
import PageHeader from '../about/PageHeader';
import './facultymembers.css';

const UserAvatarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-avatar-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const UserOutlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
  </svg>
);

const HatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="desk-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
  </svg>
);

const Nonteachingfacult = () => {
  const staffData = [
    { srNo: 1, name: "Ms. Karishma V. Singh", designation: "CEO", qualification: "Diploma in CE, Degree in CE, MBA Finance" },
    { srNo: 2, name: "Mr. V. N. Datta", designation: "Development and Quality Assurance Officer", qualification: "Msc (Physics)" },
    { srNo: 3, name: "Mr. Krishna Chauhan", designation: "Administrative Officer (Legal Affairs)", qualification: "B.A, LLB" },
    { srNo: 4, name: "Mr. Shailesh Sharma", designation: "Office Supritendant", qualification: "B.COM." },
    { srNo: 5, name: "Ms. Vanshika Mirchandani", designation: "Steno-Typist", qualification: "B.COM., DBM" },
    { srNo: 6, name: "Mr. Nikesh Mate", designation: "Accountant", qualification: "B.COM." },
    { srNo: 7, name: "Mr. Prashant Satam", designation: "Sr. Clerk", qualification: "B.COM." },
    { srNo: 8, name: "Ms. Pritam Rane", designation: "Sr. Clerk", qualification: "B.COM." },
    { srNo: 9, name: "Mr. Vilas Shinde", designation: "DTP Operator", qualification: "HSC, DTP" },
    { srNo: 10, name: "Mr. Mayur Pawar", designation: "Placement Coordinator", qualification: "BCA" },
    { srNo: 11, name: "Mr. Swapnil Yelve", designation: "Lab Assistant", qualification: "B.Com, Hardware & Networking course" },
    { srNo: 12, name: "Mr. Arvind Kumar", designation: "Lab Assistant", qualification: "SSC, Hardware & Networking, DCA" },
    { srNo: 13, name: "Mr. Ajay Singh", designation: "Lab Attendant", qualification: "B.A., Diploma in Hardware & Networking" },
   { srNo: 14, name: "Mr. Yash Birari", designation: "Lab Assistant", qualification: "B.COM." },
    // { srNo: 15, name: "Ms. Raveena K.", designation: "Lab Instructor", qualification: "B.COM." },
    // { srNo: 16, name: "Ms. Honey Kotwal", designation: "Graphic Designer", qualification: "B.COM." },
    { srNo: 15, name: "Mr. Prasann Pujare", designation: "Junior Clerk", qualification: "S.Y. B.COM." },
    { srNo: 16, name: "Ms. Sanskruti Dholam", designation: "Junior Clerk", qualification: "B.COM." },
    { srNo: 17, name: "Ms. Ankita Patel", designation: "Receptionist", qualification: "HSC" },
    { srNo: 18, name: "Mr. Surendra Arya", designation: "Driver", qualification: "SSC" },
    { srNo: 19, name: "Mr. Vikram Baria", designation: "Peon", qualification: "9th Passed" },
    { srNo: 20, name: "Mr. Ashok Prasad", designation: "Peon", qualification: "SSC" },
    { srNo: 21, name: "Mr. Mahavir Misale", designation: "Peon", qualification: "HSC" },
    { srNo: 22, name: "Mr. Mukesh Singh", designation: "Peon", qualification: "HSC" },
    { srNo: 23, name: "Mr. Pramod Phalasamkar", designation: "Peon", qualification: "HSC" },
    { srNo: 24, name: "Mr. Dilip Dubey", designation: "Peon", qualification: "8th Passed" },
    { srNo: 25, name: "Mr. Krishna Dhuri", designation: "Peon", qualification: "HSC" },
    { srNo: 26, name: "Mr. Subhash Tharli", designation: "Peon", qualification: "9th Passed" },
    { srNo: 27, name: "Ms. Pushpa Waghela", designation: "Sweeper", qualification: "7th Passed" },
    { srNo: 28, name: "Mr. Eknath Desai", designation: "Sweeper", qualification: "9th Passed" },
    { srNo: 29, name: "Ms. Deepmala Patil", designation: "Sweeper", qualification: "9th Passed" },
    { srNo: 30, name: "Mr. Ganesh Mane", designation: "Sweeper", qualification: "9th Passed" }
  ];

  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <PageHeader 
        title="Non-Teaching Staff Members" 
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Non-Teaching Staff Members' }]} 
      />

      <main className="faculty-page-main nonteaching-page">
        <div className="faculty-content-section desktop-only">
          <div className="faculty-table-wrapper">
            <table className="tims-faculty-table">
              <thead>
                <tr>
                  <th><div className="th-content"><span className="hashtag desk-icon">#</span> SR. NO.</div></th>
                  <th><div className="th-content"><UserOutlineIcon /> NAME</div></th>
                  <th><div className="th-content"><BriefcaseIcon /> DESIGNATION</div></th>
                  <th><div className="th-content"><HatIcon /> QUALIFICATION</div></th>
                </tr>
              </thead>
              <tbody>
                {staffData.map((staff) => (
                  <tr key={staff.srNo}>
                    <td className="center-text">{staff.srNo}</td>
                    <td className="fw-bold">{staff.name}</td>
                    <td className="fw-bold">{staff.designation}</td>
                    <td className="fw-bold">{staff.qualification}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mobile-only mobile-faculty-container">
          <div className="mob-cards-wrapper">
            {staffData.map((staff) => (
              <div key={staff.srNo} className="mob-faculty-card">
                <div className="mob-card-header">
                  <div className="mob-avatar"><UserAvatarIcon /></div>
                  <div className="mob-name-box">
                    <h3 className="mob-name">{staff.srNo}. {staff.name}</h3>
                    <p className="mob-designation">{staff.designation}</p>
                  </div>
                </div>
                <div className="mob-card-grid">
                  <div className="mob-grid-item">
                    <div className="mob-item-label"><HatIcon /> Qualification</div>
                    <div className="mob-item-value">{staff.qualification}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Nonteachingfacult;